"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgLocationInTheNewBuilding = function SvgLocationInTheNewBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95 1.025 3.529 3.571 1.087 4.92l2.656 1.286L4.98 8.804l1.326-2.411 2.565-1.44-2.497-1.379L4.95 1.025zm14.586 4-.91 1.63-1.54.851 1.695.82.786 1.65.832-1.514 1.644-.923-1.595-.88-.912-1.634zM14.5 18.5v-12h-7v12h7z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 12.5,
    cy: 12.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.536 15.025-.91 1.63-1.54.851 1.695.82.786 1.65.832-1.514 1.644-.923-1.595-.88-.912-1.634z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.508 8.5v9.064a1 1 0 0 1-1 1h-.462M6.545 3.543h11.003a1 1 0 0 1 1 1v2.023M3.546 6.03v11.505a1 1 0 0 0 1 1h11.03",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgLocationInTheNewBuilding);
var _default = exports["default"] = Memo;